// @flow

import _find from 'lodash/find';
import Workout from './Workout';

type Props = {
  workoutId: number,
  planWorkouts: Workout[]
}

const getWorkoutFromPlanWorkoutsById = ({ workoutId, planWorkouts }: Props): Workout => _find(planWorkouts, { id: workoutId });

export default getWorkoutFromPlanWorkoutsById;
